export default {
  "content": "<path d=\"M13.5 7.53v-.66c0-3.04-2.46-5.5-5.5-5.5s-5.5 2.46-5.5 5.5v.66c-.29.17-.5.48-.5.85v2c0 .44.28.8.67.93a4.052 4.052 0 003.8 2.96c.15.21.39.36.68.36h1.71a.85.85 0 100-1.7H7.15c-.28 0-.51.14-.67.34a3.064 3.064 0 01-2.83-2.15c.21-.18.35-.44.35-.74v-2c0-.37-.21-.67-.5-.85v-.66c0-2.48 2.02-4.5 4.5-4.5s4.5 2.02 4.5 4.5v.66c-.29.17-.5.48-.5.85v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.37-.21-.67-.5-.85z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};